import AppButton from "../../../../../components/common/AppButton";
import { SVG } from "../../../../../constants/assetLists";
import { useOperationsContext } from "../../../../../context/OperationsContextProvider";

const SCREENS = [
  { type: "dailyBrief", icon: SVG.diamondIcon },
  { type: "calendar", icon: SVG.calendarIcon },
];

function ScreenOptions() {
  const {
    showDailyBriefScreen,
    setShowDailyBriefScreen,
    showCalendarScreen,
    setShowCalendarScreen,
  } = useOperationsContext();

  const handleScreenClick = (screenType: string) => {
    if (screenType == "dailyBrief") {
      setShowDailyBriefScreen(!showDailyBriefScreen);
    } else if (screenType == "calendar") {
      setShowCalendarScreen(!showCalendarScreen);
    }
  };

  return (
    <div className="flex justify-end items-center gap-3">
      <AppButton
        className="h-full"
        iconStart={
          <img src={SVG.daySummrayIcon} className="w-[18px] h-[18px] object-contain" alt="add" />
        }
        onClick={() => window.dispatchEvent(new Event("open-day-summary"))}
      >
        סיכום היום
      </AppButton>
      {SCREENS.map((screen) => (
        <button
          key={screen.type}
          className={`w-[40px] h-[40px] rounded-lg flex justify-center items-center cursor-pointer ${
            ((screen.type == "dailyBrief" && showDailyBriefScreen) ||
              (screen.type == "calendar" && showCalendarScreen)) &&
            "bg-gradient-to-b from-[#52FFE5] to-[#69EEFFFA]"
          }`}
          onClick={() => handleScreenClick(screen.type)}
        >
          <div className="w-[20px] h-[18px]">
            <img src={screen.icon} alt="diamond" className="w-full h-full object-contain" />
          </div>
        </button>
      ))}
    </div>
  );
}

export default ScreenOptions;
